import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import api from "../../api/api";

export default function DraftInvoices() {

  const [drafts, setDrafts] = useState([]);

  const navigate = useNavigate();

  /* ======================================
     LOAD DRAFT INVOICES
  ====================================== */

  const loadDrafts = async () => {

    try {

      const res = await api.get("/billing/draft-invoices");

      setDrafts(res.data);

    } catch (err) {

      console.error("Draft load error", err);

    }

  };

  useEffect(() => {

    loadDrafts();

  }, []);

  /* ======================================
     EDIT DRAFT
  ====================================== */

  const editDraft = (draft) => {

    navigate("/billing/invoice-preview", {
      state: { draft }
    });

  };

  /* ======================================
     GENERATE FINAL INVOICE
  ====================================== */

  const generateFinal = async (id) => {

    try {

      await api.post(`/billing/generate-from-draft/${id}`);

      alert("Invoice generated");

      loadDrafts();

    } catch (err) {

      console.error("Generate invoice error", err);

    }

  };

  return (

    <Box p={4}>

      <Typography variant="h5" mb={3}>
        Draft Invoices
      </Typography>

      <Card>

        <CardContent>

          <Table>

            <TableHead>

              <TableRow>

                <TableCell>ID</TableCell>
                <TableCell>Client</TableCell>
                <TableCell>Project</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Actions</TableCell>

              </TableRow>

            </TableHead>

            <TableBody>

              {drafts.map((d) => (

                <TableRow key={d.id}>

                  <TableCell>{d.id}</TableCell>

                  <TableCell>{d.client}</TableCell>

                  <TableCell>{d.project}</TableCell>

                  <TableCell>{d.amount}</TableCell>

                  <TableCell>{d.date}</TableCell>

                  <TableCell>

                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => editDraft(d)}
                      sx={{ mr: 1 }}
                    >
                      Edit
                    </Button>

                    <Button
                      size="small"
                      variant="contained"
                      color="success"
                      onClick={() => generateFinal(d.id)}
                    >
                      Generate
                    </Button>

                  </TableCell>

                </TableRow>

              ))}

            </TableBody>

          </Table>

        </CardContent>

      </Card>

    </Box>

  );

}